import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";
import { SERVICE_OPTIONS } from "@/data/site";

const InquiryDialog = ({ open, onOpenChange, service = "general", plan = "" }) => {
  const label = SERVICE_OPTIONS.find((o) => o.value === service)?.label || "General Inquiry";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-lg border-white/10 bg-[#131316] text-white"
        data-testid={`inquiry-dialog-${service}`}
      >
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-bold text-white">
            {plan ? `Inquire: ${plan}` : label}
          </DialogTitle>
          <DialogDescription className="text-sm text-[#A1A1AA]">
            Tell us what you're building. We reply within one business day — usually faster.
          </DialogDescription>
        </DialogHeader>
        <InquiryForm
          service={service}
          plan={plan}
          testidPrefix={`inquiry-form-${service}`}
          submitLabel="Request Quote"
        />
      </DialogContent>
    </Dialog>
  );
};

export default InquiryDialog;
